import React from 'react'
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs'
import WrapperSection from '../../components/global/WrapperSection'
import FormAddEditSettings from '../../components/Settings/FormAddEditSettings'

const Settings = () => {
    return (
        <>
            <WrapperSection>
                <GlobalBreadcrumbs />
                {/* Form Add Edit Settings */}
                <FormAddEditSettings />
            </WrapperSection>
        </>
    )
}

export default Settings